import React from "react";
import UserStore from "../../stores/UserStore";
import UserDataDisplayForm from "./UserDataDisplayForm";

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      loading: true,
      buttonDisabled: false,
      editingDetails: false,
    };
  }
  async componentDidMount() {
    this.getUser();
  }
  async getUser() {
    if (!UserStore.isLoggedIn) {
      return;
    }
    try {
      let res = await fetch("/getUser", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();

      if (result && result.success) {
        this.setState({ user: result.user, loading: false });
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="app">
          <div className="container">Loading...</div>
        </div>
      );
    }
    return (
      <div className="app">
        <div className="container">
          <p>Hi {this.state.user.first_name}!</p>
          <UserDataDisplayForm user={this.state.user} />
        </div>
      </div>
    );
  }
}

export default Profile;
